import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import adc_panel_bg from '../assets/adc_panel_bg.png';
import adc_panel_center_new from '../assets/adc_panel_center_new.png';
import LanternLabs3 from '../assets/LanternLabs3.png';
import './adc_DetailPanel.css';
import PanelNavbar from './PanelNavbar';

const ADCDetailPanel = ({ isOpen, onClose, sectionData }) => {
    const nextSectionRef = useRef(null);
    const contentRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            if (contentRef.current) {
                contentRef.current.scrollTop = 0;
            }
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    const scrollToNextSection = () => {
        if (nextSectionRef.current && contentRef.current) {
            const yOffset = -100; // Offset to show the section clearly
            const container = contentRef.current;
            const element = nextSectionRef.current;
            const containerY = element.offsetTop + yOffset;
            container.scrollTo({ top: containerY, behavior: 'smooth' });
        }
    };

    return (
        <div className={`detail-panel-overlay ${isOpen ? 'open' : ''}`} onClick={onClose}>
            <div
                ref={contentRef}
                className={`detail-panel-content ${isOpen ? 'open' : ''}`}
                onClick={(e) => e.stopPropagation()}
            >
                <PanelNavbar onClose={onClose} logo="" />
                <div className="panel-container">
                    <div
                        className="panel-hero-bg"
                        style={{
                            backgroundImage: `url(${adc_panel_bg})`,
                        }}
                    ></div>
                    <div className="panel-body">
                        <h1 className="panel-main-title">AI-powered precision for accelerating ADC development</h1>
                        <p className="panel-description-text">
                            Building an ADC program? Lantern's ADC module helps you identify high-value targets, evaluate potent payload candidates, and make smarter development decisions using Lantern Labs’ advanced machine learning framework.
                        </p>
                        <button className="panel-try-btn" onClick={scrollToNextSection}>
                            <span className="panel-try-btn-text">Explore the module</span>
                        </button>
                    </div>
                    <div className="panel-center-image-container">
                        <img
                            src={adc_panel_center_new}
                            alt="ADC Module Analysis"
                            className="panel-center-image"
                        />
                    </div>

                    <div className="panel-next-section" ref={nextSectionRef}>
                        <div className="section-title-group">
                            <h2 className="section-title-large">Accelerate ADC target discovery and payload selection </h2>
                            <div className="accuracy-label-container">
                                <div className="accuracy-line"></div>
                                <div className="accuracy-ellipse"></div>
                                <span className="accuracy-text"></span>
                            </div>
                        </div>

                        <div className="section-description-rich">
                            <p>
                                <span className="text-italic-medium">ADC Module</span>
                                <span> is Lantern Labs’ artificial intelligence module designed to optimize antibody–drug conjugate development. By analyzing transcriptomic, proteomic, and mutational profiles across tumor types, the platform uncovers clinically relevant targets and evaluates payload molecules with high therapeutic potential.</span>
                            </p>

                            <p className="description-spacer"></p>

                            <p>
                                <span>Built on </span>
                                <span className="text-medium">Lantern’s RADR® platform</span>
                                <span> and validated against real-world datasets, the ADC module identifies novel targets, predicts payload suitability, and helps reduce development timelines and costs—</span>
                                <span className="text-medium">empowering teams to advance next-generation ADC therapeutics with greater precision and confidence.</span>
                            </p>

                            <p className="description-spacer"></p>

                        </div>
                    </div>

                    <div className="panel-demo-section">
                        {/* Decorative Background Elements */}
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-1" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-2" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-3" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-4" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-5" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-6" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-7" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-8" />

                        <div className="demo-content-wrapper">
                            <div className="demo-text-box">
                                <h2 className="demo-title">
                                    <span className="demo-title-light">Explore how AI analyzed multi-omics datasets surface actionable opportunities for your </span>
                                    <span className="demo-title-medium">ADC program </span>
                                    <br />
                                </h2>
                            </div>

                            <div className="demo-symbol-container">
                                <div className="demo-vertical-line"></div>
                                <div className="demo-symbol-ellipse"></div>
                                <Link
                                    to="/contact"
                                    className="demo-try-btn"
                                    style={{
                                        textDecoration: 'none',
                                        position: 'relative',
                                        left: 'unset',
                                        top: 'unset',
                                        transform: 'unset',
                                        marginTop: '50px'
                                    }}
                                >
                                    <span className="demo-try-btn-text">Contact us</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ADCDetailPanel;

